module.exports = __webpack_public_path__ + "static/slide2.d58120e5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide2.jpeg
// module id = 1703
// module chunks = 173894859265406